<div class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1 class="m-0">お知らせ</h1>
      </div><!-- /.col -->
    </div><!-- /.row -->
  </div><!-- /.container-fluid -->
</div>
<section class="content">
  <div class="container-fluid">
    <div class="card card-default color-palette-box">
      <div class="card-body">
        <div class="row">
            <h3 class="card-title left">
              2021/03/08 10:00 よりメンテナンスの予定。
            </h3>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 top">
    <a class="btn btn-primary btn-lg">
      <i class="fas fa-book-open"></i> 操作マニュアル
    </a>
  </div>
</section>
<div class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1 class="m-0">契約内容表示</h1>
      </div><!-- /.col -->
    </div><!-- /.row -->
  </div><!-- /.container-fluid -->
</div>
<section class="content">
  <div class="container-fluid">
    <div class="card card-default color-palette-box">
      <div class="card-body">
        <div class="row">
            <h3 class="card-title left">
              契約形態<br>○○○○○○○○○○○○○○○
            </h3>
        </div>
        <div class="row">
          <h3 class="card-title left">
            上限人数<br>○○○人
          </h3>
      </div>
      </div>
    </div>
  </div>
</section>